import React from 'react';
function BorderThickness({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={stroke}
      stroke="none"
      {...otherProps}
    >
      <rect width="15" height="4.17" x="2.5" y="12.5" rx="1" />
      <rect width="15" height="3.33" x="2.5" y="6.67" rx="1" />
      <rect width="15" height=".83" x="2.5" y="3.33" rx=".42" />
    </svg>
  );
}

export default BorderThickness;
